/** atonce/packages — dymek „Warunek”: hover/fokus i klik pokazują tekst (role=status), Esc i klik poza zamykają. */
document.querySelectorAll( '[data-packages] .pk__tipbtn' ).forEach( ( btn ) => {
	const tip = document.getElementById( btn.getAttribute( 'aria-controls' ) );
	if ( ! tip ) {
		return;
	}
	let pinned = false;
	const show = () => {
		tip.textContent = btn.dataset.tip || '';
		tip.classList.add( 'is-open' );
		btn.setAttribute( 'aria-expanded', 'true' );
	};
	const hide = () => {
		if ( pinned ) {
			return;
		}
		tip.classList.remove( 'is-open' );
		btn.setAttribute( 'aria-expanded', 'false' );
	};
	btn.addEventListener( 'mouseenter', show );
	btn.addEventListener( 'focus', show );
	btn.addEventListener( 'mouseleave', hide );
	btn.addEventListener( 'blur', hide );
	btn.addEventListener( 'click', () => {
		pinned = ! pinned;
		if ( pinned ) {
			show();
		} else {
			hide();
		}
	} );
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && pinned ) {
			pinned = false;
			hide();
		}
	} );
	document.addEventListener( 'pointerdown', ( e ) => {
		if ( pinned && ! btn.contains( e.target ) && ! tip.contains( e.target ) ) {
			pinned = false;
			hide();
		}
	} );
} );
